import React from 'react';
import {  Link, useNavigate } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './../Nav/Navbar.css'
import { IoHome } from "react-icons/io5";
import { TbABOff, TbCardsFilled, TbRewindBackward10 } from "react-icons/tb";

import { LuLogOut } from "react-icons/lu";
import { LuCodepen } from "react-icons/lu";
import { useState } from 'react';


export const Navbar = () => {

const [active, setActive] = useState(1);

  const navigate = useNavigate()

const handleLogout = async () => {

  const token = localStorage.getItem('token')
  console.log(token)
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const formdata = new FormData();

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    const response = await fetch(
      "https://backend.booknxtcoin.com/api/admin/logout",
      requestOptions
    );

    const result = await response.json();

    if (response.ok) {
      console.log("Logout successful:", result);
      // Perform any additional cleanup, e.g., removing token from localStorage
      localStorage.removeItem("token");
      navigate("/login");
    } else {
      console.error("Logout failed:", result);
      alert("Logout failed: " + (result.message || "Unknown error"));
    }
  } catch (error) {
    console.error("Error during logout:", error);
    alert("An error occurred. Please try again.");
  }
};

  return (
    <div className=''>

      
          <div className='bg-dark'>
              <div className='container side-dashboard d-flex flex-column justify-content-between'>
                
                <div>
                {/* className={active ===1 ? "active py-3 d-flex justify-content-center align-items-center" : "py-3 d-flex justify-content-center align-items-center" }  onClick={e => setActive} */}

                      <li className='nav-item'>
                          <Link to='/' className='top-logo d-flex'>
                            <div className='menu-logo'>
                                <LuCodepen className='side-icons mx-3'/> 
                            </div>
                            
                            <div className='menu-tittle'>
                                <h4 className="nav-links text-white fw-bolder menu-name my-auto">BookNxt</h4>
                            </div>
                          </Link>
                        </li>

                  <hr className='text-white my-2'></hr>

                  <div className='d-flex flex-column'>

                      
                        <li className='nav-item'>
                          <Link to='/' className={active ===1 ? 'active sidebarlink d-flex':'sidebarlink d-flex'} onClick={e => setActive(1)}>
                            <div className='menu-logo'>
                                <IoHome className='side-icons mx-3'/> 
                            </div>
                            
                            <div className='menu-tittle my-auto'>
                                <h6 className="nav-links text-white fw-bolder menu-name my-auto"> Customer List</h6>
                            </div>
                          </Link>
                        </li>
                        <li className='nav-item'>
                          <Link to='/cards'  className={active === 2 ? 'active sidebarlink d-flex':'sidebarlink d-flex'} onClick={e => setActive(2)}>
                          <div className='menu-logo'>
                              <TbCardsFilled className='side-icons mx-3'/>
                          </div>
                          <div className='menu-tittle my-auto'>
                              <h6 className="nav-links text-white fw-bolder menu-name my-auto">Stake</h6>
                          </div>
                          </Link>
                        </li>
                        {/* <li className='nav-item'>
                          <Link to='/rewards'  className={active === 3 ? 'active sidebarlink d-flex':'sidebarlink d-flex'} onClick={e => setActive(3)}>
                          <div className='menu-logo'>
                              <TbRewindBackward10 className='side-icons mx-3'/>
                          </div>
                          <div className='menu-tittle my-auto'>
                              <h6 className="nav-links text-white fw-bolder menu-name my-auto">Rewards</h6>
                          </div>
                          </Link>
                        </li> */}
                        {/* <li className='nav-item'>
                          <Link to='/statistics'  className={active === 3 ? 'active sidebarlink d-flex':'sidebarlink d-flex'} onClick={e => setActive(3)}>
                          <div className='menu-logo'>
                              <SiGoogleanalytics className='side-icons mx-3'/>
                          </div>
                          <div className='menu-tittle my-auto'>
                              <h6 className="nav-links text-white fw-bolder menu-name my-auto">Statistics</h6>
                          </div>
                          </Link>
                        </li>
                       */}

                  </div>

                </div>

                

                <div>
                <hr className='text-white'></hr>
                    <li className='nav-item'>
                            <Link className='sidebarlink d-flex'  onClick={handleLogout}>
                              <div className='menu-logo'>
                                  <LuLogOut className='side-icons mx-3'/> 
                              </div>
                              
                              <div className='menu-tittle'>
                                  <h6  className="nav-links text-white fw-bolder menu-name my-auto my-auto">Sign Out</h6>
                              </div>
                            </Link>
                    </li>

                </div>
                
              </div>
          </div>

    </div>
  )
}
